import { http } from "./http";

// The talent's wallet passes (the Live QR page): Apple, and Google on Android.
export const walletApi = {
  /** The pass as base64 for the native Add-to-Wallet plugin. */
  passData: () => http.get<{ base64: string }>("/wallet/apple/pass-data"),
  /** A link Safari can open when the plugin fails. */
  passLink: () => http.get<{ url: string }>("/wallet/apple/pass-link"),
  /** The .pkpass file itself (web download). */
  generatePass: () => http.post<Blob>("/wallet/apple/generate-pass", {}, { responseType: "blob" }),
  /** Google's "Add to Google Wallet" link for this talent's pass. */
  googleSaveLink: () => http.get<{ url: string }>("/wallet/google/save-link"),
};
